/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Moreoptions1Inputs */

const en_btn_moreoptions1 = /** @type {(inputs: Btn_Moreoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More options`)
};

/**
* | output |
* | --- |
* | "More options" |
*
* @param {Btn_Moreoptions1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const btn_moreoptions1 = /** @type {((inputs?: Btn_Moreoptions1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Moreoptions1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_moreoptions1(inputs)
});
export { btn_moreoptions1 as "btn_moreOptions" }